import { render, staticRenderFns } from "./confirmReceipt.vue?vue&type=template&id=2d556a65&scoped=true&"
import script from "./confirmReceipt.vue?vue&type=script&lang=js&"
export * from "./confirmReceipt.vue?vue&type=script&lang=js&"
import style0 from "./confirmReceipt.vue?vue&type=style&index=0&id=2d556a65&lang=less&scoped=true&"
import style1 from "./confirmReceipt.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d556a65",
  null
  
)

component.options.__file = "confirmReceipt.vue"
export default component.exports